import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";
import { AIProtonModel } from "@NA/Widgets/AIProton/AIProtonModel";
import { Session } from "@NA/Overrides/Services/SessionService";
import { getMaxProductHeight } from "@NA/Utils/Utility";

interface OwnProps {
    product: AIProtonModel;
    extendedStyles?: ProductDescriptionStyles;
    session: Session;
    title: string;
}

type Props = OwnProps;

export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
}

export const productDescriptionStyles: ProductDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
            align-items: flex-start;
        `,
        typographyProps: {
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
                &:hover {
                    text-decoration: underline;
                }
            `,
        },
    },
};

const AIDescription: FC<Props> = ({ product, extendedStyles, session, title }) => {
    const [styles] = React.useState(() => mergeToNew(productDescriptionStyles, extendedStyles));

    const description = product.shortDescription;
    const clickHandler = () => {
        sessionStorage.setItem('item_list_name', title);
    };
    const [minDescHeight, setMinDescHeight] = useState(15);
    
    useEffect(() => {
        const maxDescHeight = getMaxProductHeight('[data-test-selector="productDescriptionLink"]');
  
        setMinDescHeight(maxDescHeight);
    }, []);
    return (
        <Link
            {...styles.productDetailLink}
            href={product.productDetailUrl}
            alt={`See product details for ${description}`}
            data-test-selector="productDescriptionLink"
            onClick={clickHandler} style={{ minHeight: minDescHeight + "px" }}
        >
            {description}
        </Link>
    );
};

export default AIDescription;

